<template>
    <div class="px-5">
        <div class="row pt-5">
            <!-- Avatar image in the left -->
            <div class="col-sm-2 d-flex align-items-center">
                <avatar-uploader
                    :value="localCompany.imageLogo"
                    :originalImage="localCompanyOriginal.imageLogo || localCompanyOriginal.imageLogoBase64"
                    :placeholder="'agent'"
                    :showLabel="false"
                    :showPreview="true"
                    :requirementsBelowImage="true"
                    :showRequirements="false"
                    :showButton="false"

                    :isSizeOk.sync="avatarRequirements.isSizeOk"
                    :isFormatOk.sync="avatarRequirements.isFormatOk"

                    :image.sync="localCompany.imageLogo"
                    :imageBase64.sync="localCompany.imageLogoBase64"
                    :imageHash.sync="localCompany.imageLogoHash"

                    :originalImageSync.sync="localCompanyOriginal.imageLogo"
                    :originalImageBase64Sync.sync="localCompanyOriginal.imageLogoBase64"
                    :originalHashSync.sync="localCompanyOriginal.imageLogoHash"
                />
            </div>

            <div class="col-sm-6 mt-n2">
                <div class="col-sm-6 d-flex align-items-end">
                    <div>
                        <label class="full mt-1">
                            Company Brand Name
                            <span class="brand"> * </span>
                            <input type="text" class="bg-lighter" v-model="localCompany.brand" />
                        </label>

                        <div v-if="$v.localCompany.brand.$invalid" class="error">
                            <span v-if="!$v.localCompany.brand.required">Brand Name is required.</span>
                            <span v-if="!$v.localCompany.brand.minLength">Must have at least 4 characters</span>
                        </div>
                        
                        <avatar-uploader
                            class="mt-3"
                            :value="localCompany.imageLogo"
                            :originalImage="localCompanyOriginal.imageLogo || localCompanyOriginal.imageLogoBase64"
                            :placeholder="'agent'"
                            :showLabel="false"
                            :showPreview="false"
                            :showRequirements="true"
                            :showButton="true"
                            :buttonType="'logo'"

                            :isSizeOk.sync="avatarRequirements.isSizeOk"
                            :isFormatOk.sync="avatarRequirements.isFormatOk"

                            :image.sync="localCompany.imageLogo"
                            :imageBase64.sync="localCompany.imageLogoBase64"
                            :imageHash.sync="localCompany.imageLogoHash"

                            :originalImageSync.sync="localCompanyOriginal.imageLogo"
                            :originalImageBase64Sync.sync="localCompanyOriginal.imageLogoBase64"
                            :originalHashSync.sync="localCompanyOriginal.imageLogoHash"
                        />
                    </div>
                </div>
            </div>

            <div class="col-sm-4 mb-2 mt-n3 text-right">
                <input
                    type="submit"
                    value="Save"
                    class="btn green widest"
                    :class="{ tertiary: $v.localCompany.$invalid }"
                    :disabled="!isDirty"
                    @click="save"
                />
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-8">
                <div>
                    <div class="border-bottom-medium font-weight-600 darker pb-1 mb-3">
                        Company Details
                    </div>

                    <div class="mb-5">
                        <!-- Company details block -->
                        <div class="row">
                            <div class="col-sm-8 mb-2">
                                <label class="full">
                                    Legal Company Name
                                    <span class="brand"> * </span>
                                    <input
                                        type="text"
                                        class="bg-lighter"
                                        v-model="localCompany.companyName"
                                    />
                                </label>

                                <div v-if="$v.localCompany.companyName.$invalid" class="error">
                                    <span v-if="!$v.localCompany.companyName.required">Company Name is required.</span>
                                    <span v-if="!$v.localCompany.companyName.minLength">Must have at least 4 characters.</span>
                                </div>
                            </div>

                            <div class="col-sm-4 mb-2">
                                <label class="full">
                                    Website
                                    <input
                                        type="text"
                                        class="bg-lighter"
                                        v-model="localCompany.website"
                                    />
                                </label>
                                <div v-if="$v.localCompany.website.$invalid" class="error">
                                    <span v-if="!$v.localCompany.website.invalid">Must be a valid website.</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 p-0">
                            <label class="full">
                                Company Address
                                <span class="brand"> * </span>
                                <textarea
                                    class="bg-lighter"
                                    rows="2"
                                    v-model="localCompany.companyAddress"
                                ></textarea>
                            </label>

                            <div v-if="$v.localCompany.companyAddress.$invalid" class="error">
                                <span v-if="!$v.localCompany.companyAddress.required">Company Address is required.</span>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    ZIP-Code
                                    <span class="brand"> * </span>
                                    <input
                                        type="text"
                                        class="bg-lighter"
                                        v-model="localCompany.postalCode"
                                    />
                                </label>

                                <div v-if="$v.localCompany.postalCode.$invalid" class="error">
                                    <span v-if="!$v.localCompany.postalCode.required">ZIP-Code is required.</span>
                                </div>
                            </div>

                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    Location
                                    <span class="brand"> * </span>
                                    <input
                                        type="text"
                                        class="bg-lighter"
                                        v-model="localCompany.location"
                                    />
                                </label>

                                <div v-if="$v.localCompany.location.$invalid" class="error">
                                    <span v-if="!$v.localCompany.location.required">Location is required.</span>
                                </div>
                            </div>

                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    Country
                                    <span class="brand"> * </span>
                                </label>

                                <country-picker
                                    :openDirection="'bottom'"
                                    :selectedCountryValue="selectedCountry"
                                    :disabled="false"
                                    :allowEmpty="false"
                                    @input="updateCountry($event)"
                                ></country-picker>

                                <div v-if="$v.localCompany.country.$invalid" class="error">
                                    <span v-if="!$v.localCompany.country.required">Country is required.</span>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    License Number
                                    <input
                                        type="text"
                                        class="bg-lighter"
                                        v-model="localCompany.licenseNumber"
                                    />
                                </label>
                            </div>

                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    CAE
                                    <input type="text" class="bg-lighter" v-model="localCompany.cae" />
                                </label>
                            </div>

                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    VAT Number
                                    <span class="brand"> * </span>
                                    <input type="text" class="bg-lighter" v-model="localCompany.registrationNumber" />
                                </label>

                                <div v-if="$v.localCompany.registrationNumber.$invalid" class="error">
                                    <span v-if="!$v.localCompany.registrationNumber.required">VAT Number is required.</span>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <!-- group of 2 -->
                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    Registry office
                                    <input type="text" class="bg-lighter" v-model="localCompany.registryOffice" />
                                </label>
                            </div>

                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full"> Time Zone </label>

                                <v-select
                                    v-if="getTimezones"
                                    v-model="selectedTimezone"
                                    :options="timeZonesList"
                                    label="value"
                                    @input="timeZoneChanged"
                                >
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="border-bottom-medium font-weight-600 darker pb-1 mb-3">Bio</div>

                    <div class="mb-5">
                        <div class="row">
                            <div class="col-sm-8 mb-2">
                                <label class="full">
                                    Company Bio
                                    <textarea
                                        class="bg-lighter"
                                        rows="4"
                                        v-model="localCompany.biography"
                                        placeholder="Write a small biography describing your company."
                                    ></textarea>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="border-bottom-medium font-weight-600 darker pb-1 mb-3">
                        Contacts
                    </div>

                    <div class="mb-5">
                        <div class="row mt-2">
                            <div class="col-sm-8 py-0 mb-2" :class="{ error: $v.localCompany.reservationEmail.$invalid }">
                                <label class="full" :class="{ error: $v.localCompany.reservationEmail.$invalid }">
                                    <span>Email - Reservations </span><span class="brand">*</span>

                                    <span class="normal fs-smaller"
                                        >(you can enter multiple emails by separating them with
                                        comma ",")</span
                                    >

                                    <input
                                        type="text"
                                        class="bg-lighter"
                                        v-model="localCompany.reservationEmail"
                                        placeholder="email1@domain.com, email2@domain.com, email3@domain.com"
                                    />
                                </label>

                                <div v-if="$v.localCompany.reservationEmail.$invalid" class="error">
                                    <span v-if="localCompany.reservationEmail && !$v.localCompany.reservationEmail.isEmailValid">
                                        Must be a valid email.
                                    </span>
                                    <span v-if="!$v.localCompany.reservationEmail.required">
                                        Email - Reservations is required.
                                    </span>
                                </div>
                            </div>

                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    Phone - Reservations
                                    <span class="brand">*</span>
                                    <input
                                        type="text"
                                        class="bg-lighter"
                                        v-model="localCompany.reservationPhone"
                                        @blur="onPhoneBlur($event)"
                                    />
                                </label>
                                <div v-if="$v.localCompany.reservationPhone.$invalid" class="error">
                                    <span v-if="!$v.localCompany.reservationPhone.required">Phone - Reservations is required.</span>
                                    <span v-if="!$v.localCompany.reservationPhone.numeric">Must be a valid phone.</span>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-sm-8 py-0 mb-2" :class="{ error: $v.localCompany.financialEmail.$invalid }">
                                <label class="full" :class="{ error: $v.localCompany.financialEmail.$invalid }">
                                    <span>Email - Financial</span>

                                    <span class="normal fs-smaller"
                                        >(you can enter multiple emails by separating them with
                                        comma ",")</span
                                    >

                                    <input
                                        type="text"
                                        class="bg-lighter"
                                        v-model="localCompany.financialEmail"
                                        placeholder="email1@domain.com, email2@domain.com, email3@domain.com"
                                    />
                                </label>

                                <div v-if="$v.localCompany.financialEmail.$invalid" class="error">
                                    <span v-if="!$v.localCompany.financialEmail.isEmailValid">Must be a valid email. </span>
                                </div>
                            </div>

                            <div class="col-sm-4 py-0 mb-2"></div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="border-bottom-medium font-weight-600 darker pb-1 mb-3">
                        Calendar
                    </div>

                    <div class="row mt-2">
                        <div class="col-sm-4 py-0 mb-2">
                            <label class="full"> Start Hour </label>
                            <timepicker
                                class="mt-2"
                                format="hh:mm"
                                :showOnTop="true"
                                :availableHours="possibleCalendarHours"
                                :defaultTime="defaultCalendarStartHour"
                                @change="setCalendarStartTime"
                            ></timepicker>
                        </div>

                        <div class="col-sm-8 py-0 mb-2">
                            <div class="row m-0 mb-3 align-items-center w-100">
                                <label class="col-sm-8">
                                    Show sunrise and sunset events on the calendar
                                </label>

                                <div class="col-sm-4 d-flex justify-content-end">
                                    <toggle-button
                                        class="mr-3"
                                        v-model="localCompany.isToShowSunriseAndSunsetOnCalendar"
                                        :value="true"
                                        :sync="true"
                                        :labels="{ checked: 'YES', unchecked: 'NO' }"
                                    />
                                </div>

                                <div
                                    v-if="localCompany.isToShowSunriseAndSunsetOnCalendar"
                                    class="w-100"
                                >
                                    <div class="normal col-sm-12 fs-small info mt-2">
                                        Define the location (latitude and longitude) in order to
                                        help us calculate the sunrise and sunset:
                                    </div>

                                    <div class="d-flex flex-column w-100">
                                        <div class="col-sm-12">
                                            <label for="latitude" class="full mt-2">Latitude</label>

                                            <input
                                                id="latitude"
                                                type="text"
                                                class="bg-lighter col-sm-9"
                                                v-model.trim.number="localCompany.latitude"
                                                placeholder="Your latitude"
                                            />
                                        </div>

                                        <span
                                            v-if="geoError !== null"
                                            class="col-sm-12 normal fs-smaller brand mt-1"
                                        >
                                            Error: {{ geoError }}
                                        </span>

                                        <div
                                            v-if="$v.localCompany.latitude.$invalid"
                                            class="col-sm-12 normal fs-smaller brand mt-1"
                                        >
                                            <span v-if="!$v.localCompany.latitude.isLatitudeValid">Invalid latitude.</span>
                                        </div>

                                        <div class="col-sm-12">
                                            <label for="longitude" class="full mt-2">
                                                Longitude
                                            </label>

                                            <input
                                                id="longitude"
                                                type="text"
                                                class="bg-lighter col-sm-9"
                                                v-model.trim.number="localCompany.longitude"
                                                placeholder="Your longitude"
                                            />
                                        </div>

                                        <span
                                            v-if="geoError !== null"
                                            class="col-sm-12 normal fs-smaller brand mt-1"
                                        >
                                            Error: {{ geoError }}
                                        </span>

                                        <div
                                            v-if="$v.localCompany.longitude.$invalid"
                                            class="col-sm-12 normal fs-smaller brand mt-1"
                                        >
                                            <span v-if="!$v.localCompany.longitude.isLongitudeValid">Invalid longitude.</span>
                                        </div>

                                        <div class="col-sm-12 normal fs-smaller brand mt-1">
                                            <button
                                                class="btn wide mr-3 mt-2"
                                                @click="getGeolocation('coordinates')"
                                            >
                                                <i class="fas fa-crosshairs"></i>
                                                Pick location
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="border-bottom-medium font-weight-600 darker pb-1 mb-3">
                    Advanced Details
                </div>

                <div class="col-sm-12 p-0 mb-2">
                    <label class="full">
                        <span class="fs-small">Choose the best option to describe your offer.</span>
                    </label>

                    <v-select
                        class="bg-lighter"
                        label="description"
                        :options="describeOffer"
                        placeholder="Select an option"
                        v-model="selectedDescribeOffer"
                        @input="setOfferType"
                    ></v-select>
                </div>

                <div class="col-sm-12 p-0 mb-2">
                    <label class="full">
                        Tagline
                        <input
                            type="text"
                            class="bg-lighter"
                            v-model="localCompany.tagline"
                        />
                    </label>

                    <div v-if="$v.localCompany.tagline.$invalid" class="error">
                        <span v-if="!$v.localCompany.tagline.minLength">Must have at least 4 characters.</span>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mb-2 text-right">
                <input
                    type="submit"
                    value="Save"
                    class="btn green widest ml-auto"
                    :class="{ tertiary: $v.localCompany.$invalid }"
                    :disabled="!isDirty"
                    @click="save"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { required, minLength, numeric } from "vuelidate/lib/validators";
    import { latitude, longitude } from "check-geographic-coordinates";

    import extendedVSelect from "@/extends/vue-select";
    import Timepicker from "@/tools/Timepicker";
    import CountryPicker from '@/tools/CountryPicker';
    import AvatarUploader from '@/components/common/AvatarUploader.vue';
    import validationsMixin from '@/mixins/validationHelpers';

    function emptyCompany() {
        return {
            brand: "",
            companyName: "",
            companyAddress: "",
            postalCode: "",
            registrationNumber: "",
            location: "",
            country: "",
            tagline: "",
            reservationEmail: "",
            financialEmail: "",
            latitude: "",
            longitude: "",
            licenseNumber: "",
            cae: "",
            registryOffice: "",
            biography: "",
            reservationPhone: "",
            isToShowSunriseAndSunsetOnCalendar: false,
            imageLogo: null,
            imageLogoBase64: null,
            imageLogoHash: null,
        };
    }

export default {
    mixins: [validationsMixin],
    props: ["company"],
    data() {
        return {
            localCompany: { ...emptyCompany(), ...this.company },
            localCompanyOriginal: { ...emptyCompany(), ...this.company },
            selectedTimezone: null,
            describeOffer: [],
            selectedDescribeOffer: {},
            possibleCalendarHours: [
                "00","01","02","03","04","05","06","07","08","09","10","11","12",
                "13","14","15","16","17","18","19","20","21","22","23","24"
            ],
            geoError: null,
            selectedCountry: null,
            isDirty: false,
            avatarRequirements: {
                isSizeOk: true,
                isFormatOk: true
            },
        };
    },

    validations: {
        localCompany: {
            brand: {
                required,
                minLength: minLength(4)
            },
            companyName: {
                required,
                minLength: minLength(4)
            },
            companyAddress: { required },
            postalCode: { required },
            registrationNumber: { required },
            location: { required },
            country: { required },
            tagline: {
                minLength: minLength(4),
            },
            reservationPhone: {
                required,
                validPhone(val) {
                    return this.validatePhoneNumber(val);
                }
            },
            reservationEmail: {
                required,
                isEmailValid(val) {
                    return this.isValid(val, 'email');
                }
            },
            financialEmail: {
                isEmailValid(val) {
                    return !val || this.isValid(val, 'email');
                }
            },
            website: {
                isWebsiteValid(val) {
                    return !val || this.isValid(val, 'website');
                }
            },
            latitude: {
                isLatitudeValid(val) {
                    return this.validateCoordinate(val, 'latitude');
                }
            },
            longitude: {
                isLongitudeValid(val) {
                    return this.validateCoordinate(val, 'longitude');
                }
            },
        }
    },
    watch: {
        company: {
            handler(newVal) {
                this.localCompany = { ...emptyCompany(), ...newVal };
                this.localCompanyOriginal = { ...emptyCompany(), ...newVal };
                this.isDirty = false;
                this.$emit('dirty-changed', false);
            },
            immediate: true,
            deep: true
        },
        localCompany: {
            handler() {
                this.isDirty = !this.objectsEqual(this.localCompany, this.localCompanyOriginal);
                this.$emit('dirty-changed', this.isDirty);
            },
            deep: true,
        },
    },
    created() {
        this.selectedTimezone = {
            label: this.company.timezone,
            value: this.company.timezone,
        };

        const defaultCountry = this.getCountries.find(c => c.default);
        this.selectedCountry = this.getCountries.find(c => c.id === this.company.country) || defaultCountry;
    },
    computed: {
        ...mapGetters([
            "getCountries",
            "getTimezones"
        ]),
        countriesStored() {
            return this.getCountries.map(country => ({
                label: country.name,
                value: country.id,
            }));
        },
        timeZonesList() {
            return this.getTimezones ? this.getTimezones.map((timeZone) => ({
                label: timeZone.value,
                value: timeZone.value
            })) : [];
        },
        defaultCalendarStartHour() {
            if (this.company.calendarTimeStart) {
                return this.company.calendarTimeStart.split(":");
            } else {
                return ["08", "00"];
            }
        },
        defaultCalendarEndHour() {
            if (this.company.calendarTimeEnd) {
                return this.company.calendarTimeEnd.split(":");
            } else {
                return ["24", "00"];
            }
        },
        getIsToShowSunsetSunrise: {
            get() {
                return this.company.showSunriseSunset;
            },
            set(value) {
                this.company.showSunriseSunset = value;
            },
        },
    },

    asyncComputed: {
        async offerTypes() {
            try {
                let response = await axios.get("/api/settings/GetSupplierOfferTypes");

                if (response && response.status === 200 && response.data && response.data.length > 0) {
                    this.describeOffer = response.data;
                    this.setDefaultOfferType;

                    // Sets the dropdown with the correct initial offerType from API
                    for (let offerTypeOption of this.describeOffer) {
                        if (offerTypeOption.id == this.company.offerType) {
                            this.selectedDescribeOffer = offerTypeOption;
                        }
                    }

                    return response.data;
                }
            } catch (error) {
                this.$toasted.error(error.response.data.message);
            }
        },
    },

    methods: {
        ...mapActions([
            "saveSettingsCompany",
            "flushEvents",
        ]),
        getGeolocation(payload) {
            if (payload === "latitude" || payload === "longitude" || payload === "coordinates") {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            if (payload === "coordinates") {
                                this.localCompany.latitude = position.coords.latitude;
                                this.localCompany.longitude = position.coords.longitude;
                            } else {
                                this.localCompany[payload] = position.coords[payload];
                                this.geoError = null;
                            }
                        },
                        (error) => {
                            this.localCompany[payload] = null;

                            switch (error.code) {
                                case error.PERMISSION_DENIED:
                                    this.geoError = "Geolocation permission denied.";
                                    break;
                                case error.POSITION_UNAVAILABLE:
                                    this.geoError = "Geolocation information is unavailable.";
                                    break;
                                case error.TIMEOUT:
                                    this.geoError = "Geolocation request timed out.";
                                    break;
                                default:
                                    this.geoError = `Error getting location: ${error.message}`;
                            }
                        }
                    );
                } else {
                    this.localCompany[payload] = null;
                    this.geoError = "Geolocation is not supported by your browser.";
                }
            }
        },
        validateCoordinate(val, type) {
            if (val === "") this.localCompany[type] = null;
            if (val !== null && (!val || val == "")) return false;
            if (val === null) return true;

            const validators = { latitude, longitude };

            return validators[type](val) && this.isValid(val, 'coordinates');
        },
        updateCountry(selectedCountry) {
            let oldCountry = this.localCompany.country;
            this.selectedCountry = selectedCountry;

            if (selectedCountry !== null) {
                this.localCompany.country = selectedCountry.id;

                if (typeof this.localCompany.country === "undefined") {
                    this.localCompany.country = oldCountry;
                }
            }
        },
        setOfferType(e) {
            this.localCompany.offerType = e.id;
        },
        setCalendarStartTime(e) {
            this.localCompany.calendarTimeStart = `${e}:00`;
        },
        setCalendarEndTime(e) {
            this.localCompany.calendarTimeEnd = e == "24:00" ? "23:59:59" : e;
        },
        timeZoneChanged(e) {
            this.localCompany.timezone = e.value;
        },
        objectsEqual(obj1, obj2) {
            return JSON.stringify(obj1) === JSON.stringify(obj2);
        },
        save() {
            const avatarInvalid = !this.avatarRequirements.isSizeOk || !this.avatarRequirements.isFormatOk;

            if (this.$v.localCompany.$invalid || avatarInvalid) {
                this.$dialog
                    .alert(
                        '\
                            <div class="fs-larg font-weight-600 mb-4">Invalid configuration</div>\
                            <div>Please check the fields marked red, and try again.</div>',
                        { okText: "Ok" }
                    )
                    .then(function () {});
                return;
            } else {
                Object.assign(this.company, this.localCompany);
                this.saveSettingsCompany(this.company);
                this.flushEvents();
                this.localCompanyOriginal = { ...this.localCompany }; // Reset original after save
                this.isDirty = false;
                this.$emit('dirty-changed', false);
            }
        },
        validPhone(val) {
            return /^(\+)?[0-9]+$/.test(val);
        },
        onPhoneBlur(event) {
            this.localCompany.reservationPhone = this.formatPhoneOnBlur(event.target.value);
        },
    },

    components: {
        vSelect: extendedVSelect,
        Timepicker,
        CountryPicker,
        AvatarUploader
    },
};
</script>

<style lang="scss" scoped>
    .avatarImage {
        max-width: 100%;
    }

    textarea {
        min-height: 77px;
    }
</style>



// WEBPACK FOOTER //
// TabCompany.vue?4f6fb35d